import {Component, ElementRef, EventEmitter, Output, ViewChild} from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";

@Component({
  selector: 'app-upload-dialog',
  standalone: true,
  imports: [
    MatIcon,
    MatIconButton
  ],
  templateUrl: './upload-dialog.component.html',
  styleUrl: './upload-dialog.component.scss'
})
export class UploadDialogComponent {
  @Output() hideUploadDialog: EventEmitter<void> = new EventEmitter<void>();
  @Output() fileUploadEvent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('uploadInput') uploadInput: ElementRef;
  uploadError: string;
  fileName: string;

  constructor() {}

  onFileUpload(event) {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      if (file.type === 'text/csv') {
        this.fileUploadEvent.emit(file);
        this.hideUploadDialog.emit();
      } else {
        this.uploadError = 'File format must be CSV.';
        return;
      }
    }
  }

  onHideUploadModal() {
    this.deleteFile();
    this.hideUploadDialog.emit();
  }

  onUploadOverlayClick(e) {
    if (e.target.id === 'dropZoneOverlay') {
      this.onHideUploadModal();
    }
  }

  deleteFile() {
    this.uploadInput.nativeElement.value = '';
    this.fileName = null;
    this.uploadError = null;
  }
}
